import getTags from '@/server/graphql/getTags';
import { TagsFragment } from '@/server/graphql/getTags/TagsQuery.generated';

const hasTag = async (tag: keyof TagsFragment) => {
  const tags = await getTags();
  return !!tags[tag];
};

export default hasTag;
